import { useSearchContext } from '../../../../context/PlpContext';

export const useAlternativeSuggestionData = () => {
  const search = useSearchContext();

  return {
    search,
  };
};
